<template>
    <div v-loading="pageLoading">
        <div class="content-box account-info first">
            <div style="min-height: 500px">
                <el-form :model="formData" class="sr-from-single" ref="formData" :rules="rules" label-width="150px">
                    <el-form-item label="旧手机号">
                        <el-input placeholder="手机号码" min="11" disabled max="11" v-model="oldTelephone"></el-input>
                    </el-form-item>
                    <el-form-item label="新手机号" prop="telephone">
                        <el-input placeholder="手机号码" min="11" max="11" v-model="formData.telephone"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="verificationCode" :rules="[{required: true, message: '请输短信验证码'}]">
                        <el-input placeholder="请输入短信验证码" v-model="formData.verificationCode"></el-input>
                        <el-button @click="sendSms" :disabled="smsTime == 0 ? false : true" class="underline sms-code" type="text">
                            {{ smsTime === 0 ? '点击获取' : `（${smsTime}S）` }}
                        </el-button>
                    </el-form-item>
                </el-form>
                <div style="text-align: center">
                    <el-button @click="onColse">取 消</el-button>
                    <el-button type="primary" :loading="nextLoading" @click="sendPhone">修改</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {MessageBox} from 'element-ui';
export default {
    data() {
        return {
            pageLoading: false,
            formData: {
                telephone: '', // 新手机号
                verificationCode: '', // 短信验证码
            },
            oldTelephone: '',
            smsTime: 0,
            nextLoading: false,
            fddInfo: {},
            rules: {
                telephone: {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value === null || value === '' || value === undefined) {
                            callback(new Error('请输入新手机号'));
                        } else if (!/^\d{11}$/.test(value)) {
                            callback(new Error('请输入正确的手机号码'));
                        } else {
                            callback();
                        }
                    },
                    trigger: ['blur', 'change']
                },
                verificationCode: {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value === null || value === '' || value === undefined) {
                            callback(new Error('请输入短信验证码'));
                        } else {
                            callback();
                        }
                    },
                    trigger: ['blur', 'change']
                }
            },
            verifyState: 0, // 记录认证状态用于判断是否成功
            oldTransactionNo: null
        };
    },
    created() {
        this.getPhoneInfo();
    },
    methods: {
        // 更新成功
        async updateSuccess() {
            this.$message.success('手机号修改成功');
            await this.$store.dispatch('getUserInfo');
            return (window.location.href = '/manage/accountManage');
        },
        // 获取认证状态
        async getPhoneInfo() {
            this.successLoading = true;
            const response = await this.$request.post('/fabigbig/personTeleCertInfo');
            const {state, result, msg} = response.data;
            if (!state) return this.$message.error(msg || '');
            const {oldTelephone, isVerify, verifyUrl, transactionNo} = result;
            this.oldTelephone = oldTelephone;
            this.formData = {...this.formData};
            this.status = isVerify;
            this.fddInfo = result;
            if (this.fddInfo.isMiniApp == 3) return this.$message.error('请在小程序端进行相关操作');
            /**
             * 判断是否认证成功
             * 1、isVerify为0 未发起过认证 去修改姓名
             * 2、上一次认证已经完成 本次修改姓名
             */
            if (isVerify == 2 || (isVerify == 0 && isVerify !== this.verifyState)) {
                this.updateSuccess();
            }
            if (isVerify !== this.verifyState) this.verifyState = isVerify;
            //有事务编号 且 认证状态为 1 认证中
            if(transactionNo && isVerify == 1) {
                this.waitConfirm([1,2] ? 2 : isVerify, verifyUrl, transactionNo);
            }
        },
        onColse() {
            this.$router.go(-1);
        },
        // 修改等待
        async waitConfirm(status, url, transactionNo) {
            const flag = await this.$fadadaConfirm('修改认证', '请确认是否完成了实名认证', status, url);
            if(flag == 'success'){
                const respnonse = await this.$request({
                    url: '/fabigbig/verifyFinish',
                    params: {transactionNo},
                    method: 'GET',
                });
                const {state, msg, result} = respnonse.data;
                if (!state) return this.$message.error(msg || '认证失败');
                //真正的认证成功
                if (result == false) {
                    MessageBox.confirm('认证信息更新可能会延迟1-2分钟，如果您确认认证成功，请您稍后刷新页面', '提示', {
                        confirmButtonText: '我知道啦',
                        cancelButtonText: '取消',
                        type: 'warning',
                    })
                        .then(() => {})
                        .catch(() => {});
                } else { 
                    this.getPhoneInfo();
                }
            }
            if (flag == 'refresh') this.getPhoneInfo();
        },
        async sendSms() {
            const {telephone} = this.formData;
            if (this.smsTime > 0) return;
            if (!telephone || !/^\d{11}$/.test(telephone)) return this.$message.error('请输入正确的手机号');
            const response = await this.$request({
                url: '/code/add/login/sms',
                method: 'post',
                params: {
                    telephone,
                },
            });
            const {msg, state} = response.data;
            if (!state) return this.$message.error(msg || '');
            this.smsTime = 60;
            const smsInterval = setInterval(() => {
                this.smsTime -= 1;
                if (this.smsTime <= 0) clearInterval(smsInterval);
            }, 1000);
        },
        // 修改手机号
        async sendPhone() {
            if (this.fddInfo.isMiniApp == 3) return this.$message.error('请在小程序端进行相关操作');
            const { verificationPlatform } = this.$store.state;
            //当前是电子签 跳转到法大大认证页面
            if(verificationPlatform == 1){
                this.$refs['formData'].validate(async (valid) => {
                    if (!valid) return;
                    const {telephone, verificationCode} = this.formData;
                    this.nextLoading = true;
                    const response = await this.$request.post(
                        '/fabigbig/personTeleCertVerify',
                        {
                            telephone,
                            verificationCode,
                        },
                        {formData: false}
                    );
                    const {msg, state, result} = response.data;
                    this.nextLoading = false;
                    if (!state) return this.$message.error(msg || '修改手机号失败');

                    MessageBox.confirm('您需要重新认证后签约', '重新认证', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    })
                        .then(() => {
                            const routerParams = JSON.stringify({
                                reVerifyType: 1,
                                telephone: this.formData.telephone,
                            });
                            sessionStorage["routerParams"] = routerParams;
                            this.$router.push(`/manage/contract/verify/fdd/step/1?reVerifyType=1`);
                        })
                        .catch(() => {
                            this.$router.go(-1);
                        });
                });
            }
            //当前是法大大 走之前的逻辑
            else {
                this.$refs['formData'].validate(async (valid) => {
                    if (!valid) return;
                    this.nextLoading = true;
                    const {telephone, verificationCode} = this.formData;
                    const response = await this.$request.post(
                        '/fabigbig/personTeleCert',
                        {
                            telephone,
                            verificationCode,
                        },
                        {formData: false}
                    );
                    const {msg, state, result} = response.data;
                    this.nextLoading = false;
                    if (!state) return this.$message.error(msg || '修改手机号失败');
                    /**
                     * 
                        if (isVerify == 0) return 1;//未认证
                        // 未签约 isContractSigned 是否签署合同  isPersonContractSigned 表示是否签署过个人合同
                        if (isContractSigned == 0 || (isPersonContractSigned == 1 && isContractSigned == 0)) return 2;
                        // 是否试用 4：已试用单曲  3：未试用
                        if (isPaid == 0) return canExperienceRelease ? 3 : 4;
                        // 已过期的付费用户
                        if (isExpired == 1 && isPaid == 1) return 5;
                        // 正常的VIP用户
                        if (isExpired == 0 && isPaid == 1) return 6;
                     */
                    if (this.$store.getters.userState >= 2) {
                        const flag = await this.$msgbox({
                            title: '前往电子合同平台“法大大”',
                            message: '即将前往电子合同平台“法大大”，在该平台，你将，完成实名认证。',
                            confirmButtonText: '确认前往',
                        });
                        if (flag === 'cancel') return;
                        result.verifyUrl && window.open(result.verifyUrl);
                        this.getPhoneInfo();
                    } else {
                        this.updateSuccess();
                    }
                });
            }
        },
        // 获取认证信息
        async certificationInfo() {
            this.pageLoading = true;
            const response = await this.$request.post(
                '/fabigbig/getIdentificationInformation',
                {reVerifyType: 1},
                {formData: false}
            );
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '获取用户信息失败');
            this.pageLoading = false;
            //有事务编号 就弹框：实名认证
            if (result.transactionNo) {
                this.hasTransactionNo = true;
            }
        }
    },
};
</script>
<style lang="scss">
.update-phone-dialog {
    .el-dialog__body {
        padding: 0px 60px;

        .item {
            display: block;

            label {
                color: $--color-font-normal;
            }
        }
    }
}

.form-body {
    .el-form-item__label {
        text-align: left;
    }

    .underline {
        position: absolute;
        right: 10px;
        top: 10px;
        font-weight: bold;
    }

    .item {
        display: flex;
        margin-top: 10px;

        label {
            width: 80px;
            line-height: 40px;
        }

        .cont {
            flex: 1;
            display: flex;
        }

        .el-button {
            padding: 10px 20px;
        }

        .error {
            color: $--color-font-error;
        }
    }
}

.qr-content {
    text-align: center;

    b {
        color: #333;
    }

    .qrcode {
        margin-top: 20px;
        text-align: center;
        display: inline-block;
    }
}
</style>
